import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../../components/button';
import Popup from '../../../../components/popup';
import { isRejectDeletionPopupShown } from '../../../../../actions/popupActions';
import { isLoadingSuspiciousContactsDeletionAction, putSuspiciousContactsDeletion } from '../../../../../actions/suspiciousContactsDeletionActions';
import {Trans, useTranslation} from 'react-i18next';

function RejectDeletionPopup () {

    const suspiciousContactsDeletion = useSelector((state) => state.suspiciousContactsDeletionReducer.fetchSuspiciousContactsDeletion);
	const { t } = useTranslation();
    const dispatch = useDispatch();

    const closePopup = () => {
        dispatch(isRejectDeletionPopupShown(false))
    };

    const handleCancelDeletion = () => {
		dispatch(putSuspiciousContactsDeletion('reject'));
		dispatch(isLoadingSuspiciousContactsDeletionAction(true));
        dispatch(isRejectDeletionPopupShown(false));
	};

    return (
        <Popup className="p-4"
                onClose={closePopup}>
	        <div className="popup-with-picture">
		        <div className="popup-with-picture__text">
			        <h2 className="pr-5">
				        <Trans i18nKey="rejectDeletionPopupTitle" values={{nbrOfContacts: suspiciousContactsDeletion.totalNoOfContactsNeededToActionOn > 0
						        ?
						        suspiciousContactsDeletion.totalNoOfContactsNeededToActionOn
						        :
						        suspiciousContactsDeletion.totalNoOfContactsOwnerNeededToReviewOn > 0
							        ?
							        suspiciousContactsDeletion.totalNoOfContactsOwnerNeededToReviewOn
							        :
							        suspiciousContactsDeletion.totalNoOfContactsAdminNeededToReviewOn > 0
								        ?
								        suspiciousContactsDeletion.totalNoOfContactsAdminNeededToReviewOn
								        :
								        '0'}}  />
			        </h2>
			        <p>{t('rejectDeletionPopupText')}</p>
			        <Button onClick={handleCancelDeletion} className="btn-primary mr-2">{t('confirmBtn')}</Button>
			        <Button onClick={closePopup} className="btn-outline-primary ml-2">{t('getBackText')}</Button>
		        </div>
		        <div className="popup-with-picture__picture">
			        <img src="/img/approve-or-reject-contacts-deletion.png" alt="Approve or reject contacts deletion"/>
		        </div>
	        </div>
        </Popup>
    )
}

export default RejectDeletionPopup;
